<template>
  <div class="form-elements va-row">

      <div class="flex sm4 xs12 offset--sm4">
        <va-card :title="$t('Create Account')">

          <loading :active.sync="loading" :is-full-page="false"></loading>

          <form @submit.prevent="onsubmit()" class="text-right">
                
                <va-input
                  name = "Phrase"
                  v-model="payload.phrase"
                  v-validate="{required: true}"
                  placeholder="Phrase"
                  :errorMessages="[phrase_err]"
                  :error="phrase_has_err"
                />
                
                <va-button color="success" :to="{ name: 'WatchedPhraseList' }" >Back</va-button>
                <va-button color="info" type="submit">Create watched phrase</va-button>
              
          </form>
        </va-card>
      </div>

  </div>
</template>

<script>

import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';
import Validation from '@/mixins/ValidationMixin';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'phrase-form',
  mixins: [Validation.Validation],
  components:{Loading},
  data () {
    return {
      loading: false,
      payload: {
        phrase:""
      }
    }
  },

  computed: {

    ...Validation.mapValidationKeys([
        "phrase",
        "password"
    ]),

  },

  methods: {

     ...mapActions({
      save: 'createPhrase'
    }),

    onsubmit () {

      this.loading  = true;
      this.save( this.payload ).then( response => {
          this.$router.push({ name: 'WatchedPhraseList' })
      }).catch( exeption => (this.valErr = exeption,this.loading = false ));


    }
  }
}
</script>

<style>
  .row.row-inside {
    max-width: none;
  }
</style>
